import { queryClient } from '../App'
import { checkCorrectVersion } from '../services/ApiService.js'

export const useCheckVersion = () => {
  const checkVersion = async () => {
    const data = await queryClient.fetchQuery({
      queryKey: ['check-version'],
      queryFn: () => checkCorrectVersion(),
    })

    return !!data?.version
  }

  return { checkVersion }
}
